module.exports = __webpack_public_path__ + "img/shurflo_soft.e93059c0.png";